import React, { useState, FC, useEffect } from "react";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { customerService } from "@/views/base/customer/customerService";
import { useGlobalModel } from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDtpDetailModel } from "./dtpDetailModel";

export const FormBox: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const {
        addFormVal,
        editFormVal,
        updateFormVal,
    } = useDtpDetailModel(({ addFormVal, editFormVal }) => [addFormVal, editFormVal]);

    const { fetchCustomerList } = useGlobalModel(() => []);
    const { getSelectedDictOne } = useDictModel(() => []);

    const formVal = mode === "edit" ? editFormVal : addFormVal;

    //回显选中客户带出来的数据
    const getCustomer = async (id: string) => {
        let { retData } = await customerService.one(id);
        let data = {
            customerCode: retData.code,
            customerName: retData.name,
            customerId: retData.id,
            phone: retData.phone,
            contact: retData.contact,
            countryCode: retData.countryCode,
            countryName: retData.countryName
        }
        updateFormVal(mode, data);
    }

    //客户选中
    const customerChange = (value: string, option: ISelectOption) => {
        if (option && option.id) {
            getCustomer(option.id as string)
        }
    }

    //币种选中
    const currencyChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { currencyCode: option.value, currencyName: option.label });
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        updateFormVal(mode, values);
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px" },
        contentClass: "pr-2",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "文件编号",
                fieldName: "code",
                rules: [{ required: true, message: "请输入文件编号" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "文件名称",
                fieldName: "agreementName",
                rules: [{ required: true, message: "请输入文件名称" }],
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "文件类型",
                fieldName: "agreementType",
                options: getSelectedDictOne(DictCodeEnmu.DOCUMENT_TYPE),
                rules: [{ required: true, message: "请选择文件类型" }],
            }, {
                //     type: FormItemTypeEnum.Select,
                //     fieldLabel: "销售实体",
                //     fieldName: "currencyCode",
                //     options: [],
                //     rules: [{ required: true, message: "请选择销售实体" }]
                // }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "合作方",
                fieldName: "partner",
                rules: [{ required: true, message: "请输入合作方" }]
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "签订日期",
                format: "YYYY-MM-DD",
                showTime: false,
                fieldName: "signingTime",
                rules: [{ required: true, message: "请选择签订日期" }]
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "到期日期",
                format: "YYYY-MM-DD",
                showTime: false,
                fieldName: "expireTime",
                rules: [{ required: true, message: "请选择到期日期" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "是否预警",
                fieldName: "warningStatus",
                options: [{ label: "是", value: 0 }, { label: "否", value: 1 }],
                // rules: [{ required: true, message: "请选择文件类型" }],
            },
        ]
    };

    const stockEntryFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 8 },
        labelAlign: "right",
        formValues: formVal,
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...stockEntryFromConfig} />
    )
}